import { render, staticRenderFns } from "./CaptchaModal.vue?vue&type=template&id=31ea981e&scoped=true"
import script from "./CaptchaModal.vue?vue&type=script&lang=js"
export * from "./CaptchaModal.vue?vue&type=script&lang=js"
import style0 from "./CaptchaModal.vue?vue&type=style&index=0&id=31ea981e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ea981e",
  null
  
)

export default component.exports